<template>


  <card>


    <form>

      <div class="row">
        <div class="col-md-6">
          <h4 slot="header" class="card-title">Profile</h4>
        </div>
        <div class="col-md-6">
          <!-- <button type="button" class="btn btn-primary pricing"">Upgrade</button> -->
        </div>
      </div>


      <div class="row">
        <div class="col-md-4">
          <base-input type="text"
                    label="Company"
                    :disabled="false"
                    placeholder="Company"
                    v-model="user.CompanyName">
          </base-input>
        </div>

        <div class="col-md-4">
          <base-input type="text"
                    label="License"
                    :disabled="true"
                    placeholder="License"
                    v-model="user.PricePlan">
          </base-input>
        </div>

        <div class="col-md-4">
          <base-input type="text"
                    label="Invite Code"
                    :disabled="true"
                    placeholder="Invite Code"
                    v-model="user.InviteCode">
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <base-input type="text"
                    label="Name"
                    placeholder="Name"
                    v-model="user.ContactPerson">
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input type="text"
                    label="Designation"
                    placeholder="Designation"
                    v-model="user.Designation">
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <base-input type="text"
                    label="Mobile"
                    placeholder="Mobile"
                    v-model="user.Mobile">
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input type="text"
                    label="Email"
                    :disabled="true"
                    placeholder="Email"
                    v-model="user.Email">
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <base-input type="text"
                    label="Address"
                    placeholder="Address"
                    v-model="user.address">
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <base-input type="text"
                    label="City"
                    placeholder="City"
                    v-model="user.city">
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input type="text"
                    label="Country"
                    placeholder="Country"
                    v-model="user.country">
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input type="number"
                    label="Postal Code"
                    placeholder="ZIP Code"
                    v-model="user.postalCode">
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <base-input type="text"
                    label="Sign Up Date"
                    placeholder="Name"
                    :disabled="true"
                    v-model="user.SignUpDate">
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input type="text"
                    label="Expires On"
                    :disabled="true"
                    placeholder="Expires On"
                    v-model="user.ExpiresOn">
          </base-input>
        </div>
      </div>


      <div class="row">
        <div class="col-md-6">
          <base-input type="text"
                    label="Button Text"
                    placeholder="Button Text"
                    v-model="user.ButtonText">
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input type="text"
                    label="Redirect URL"
                    placeholder="Redirect URL"
                    v-model="user.RedirectURL"
                    >
          </base-input>
        </div>
      </div>


      <div class="text-center">
        <button type="submit" class="btn btn-primary btn-fill float-right" @click.prevent="updateProfile">
          Update Profile
        </button>
      </div>
      <div class="clearfix"></div>
    </form>

      <transition name="fade" v-if="showSuccess">
        <div class="alert alert-primary" role="alert">
          Saved Successfully
        </div>
      </transition>

  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import { globalStore } from '../../main.js';
  import { db } from '../../main.js';
  import moment from 'moment';



  export default {
    components: {
      Card
    },
    data () {
      return {
        showSuccess: false,
        CompanyId: globalStore.AdminId,
        user: {
          company: '',
          username: '',
          email: '',
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          country: '',
          postalCode: ''        }
      }
    },
    beforeMount(){
      console.log("Profile beforeMount");
      // console.log(globalStore.UserInfo)

      this.user = globalStore.UserInfo;
      // console.log("UserInfo: "+JSON.stringify(this.user, null, 2));

      // this.user.SignUpDate = moment(this.user.CreatedOn).format('DD MMM YYYY');
      // this.user.ExpiresOn = "NA";
      // // this.ExpiresOn = moment().format();

      //               if(this.user.PricePlan == 'Business' || this.user.PricePlan == 'Thermal'){
      //                 this.user.ExpiresOn = "";
      //               }else{
      //                 this.user.ExpiresOn = "";                      
      //               }

    },
    mounted(){
      console.log(this.CompanyId);
      this.GetCompanyInfo();
    },
    methods: {
      ShowToast(){
        this.showToast = true;
      },
      updateProfile () {
        console.log("updateProfile");
        console.log(this.user)

              db.collection("Company")
                  .doc(this.CompanyId)
                  .update(this.user)
                  .then(() => {
                    console.log("Company Info Updated.")

                    this.notifyVue('bottom', 'right');

                    this.GetCompanyInfo();
                  })
                  .catch(error => {
                    console.error("Error removing document: ", error);
                  });        

      },
      notifyVue (verticalAlign, horizontalAlign) {
        // const color = Math.floor((Math.random() * 4) + 1)
        this.$notifications.notify(
          {
            message: `<b>Saved Successfully</b>`,
            icon: 'nc-icon nc-check-2',
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: 'primary'
          })
      },
      GetCompanyInfo(){

              console.log("--- Refresh CompanyInfo ---");
              db.collection('Company')
                .doc(this.CompanyId)
                .get()
                .then((doc) => {

                  if(doc.exists){
                    console.log(doc.data());
                    this.user = doc.data();

                    this.user.SignUpDate = moment(this.user.CreatedOn).format('DD MMM YYYY');

                    if(this.user.PricePlan == 'Business' || this.user.PricePlan == 'Thermal'){
                      this.user.ExpiresOn = "";
                    }else{
                      this.user.ExpiresOn = "";                      
                    }

                  }
                })
                .catch((e) => {
                  console.log('Error:', (e));
                });

      },
    }
  }

</script>
<style scoped="">

.pricing{
  float: right;
}

</style>
